import mascot from "@/assets/alpha-mascot.png";

export default function Mascot({ size = 96, className = "" }) {
  return (
    <img
      src={mascot}
      alt="Alpha — mascote técnico"
      style={{ width: size, height: size }}
      className={`object-contain drop-shadow-[0_8px_24px_rgba(212,175,55,0.25)] ${className}`}
      data-testid="alpha-mascot"
    />
  );
}
